import { userClient } from '../config/api';
import {
  Inspector,
  GetInspectorsByProviderParams
} from './types/user.types';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';

class UserService {
  
  async getInspectorsByProvider(params: GetInspectorsByProviderParams): Promise<Inspector[]> {
    try {
      const url = `/api/users/inspectors/provider/${params.providerId}`;
      const requestParams = {
        page: params.page || 1,
        pageSize: params.size || 10
      };

      const response = await userClient.get<any>(url, {
        params: requestParams
      });

      if (response.data.success && response.data.data) {
        const inspectors = response.data.data.data || response.data.data.items || response.data.data;

        return Array.isArray(inspectors) ? inspectors : [];
      }

      return [];
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao buscar inspetores');
    }
  }

  async getInspectorsWithDirectAssignment(params: { page: number; size: number }): Promise<Inspector[]> {
    try {
      const url = '/api/users/inspectors/direct-assignment';
      const requestParams = {
        page: params.page || 1,
        pageSize: params.size || 50
      };

      const response = await userClient.get<any>(url, {
        params: requestParams
      });

      if (response.data.success && response.data.data) {
        const inspectors = response.data.data.data || response.data.data.items || response.data.data;

        return Array.isArray(inspectors) ? inspectors : [];
      }

      return [];
    } catch (error: unknown) {
      apiErrorHandler(error, 'Erro ao buscar inspetores com direcionamento direto');
    }
  }
}

export const userService = new UserService();